module.exports = __webpack_public_path__ + "media/images/icon-team-83dee525e7777b8c4c758b92ded1a487.svg";